import exifr from 'exifr';

const thumbnailSize = 256;

function createThumbnail(img) {
  return new Promise((resolve) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    // Calculate the dimensions for the thumbnail
    const maxWidth = thumbnailSize; // Adjust this as needed
    const maxHeight = thumbnailSize; // Adjust this as needed
    let width = img.width;
    let height = img.height;

    if (width > maxWidth || height > maxHeight) {
      const aspectRatio = width / height;
      if (width > maxWidth) {
        width = maxWidth;
        height = maxWidth / aspectRatio;
      }
      if (height > maxHeight) {
        height = maxHeight;
        width = maxHeight * aspectRatio;
      }
    }

    // Set the canvas size
    canvas.width = width;
    canvas.height = height;

    // Draw the image on the canvas to create the thumbnail
    ctx.drawImage(img, 0, 0, width, height);

    // Convert the canvas to a Blob with JPG format
    canvas.toBlob(resolve, 'image/jpeg');
  });
}

function createVideoThumbnail(file, videoDimensions) {
  return new Promise((resolve) => {
    const videoPath = URL.createObjectURL(file);

    const video = document.createElement('video');
    video.onerror = (e) => { console.log(e); };
    video.onloadeddata = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      // Calculate the dimensions for the thumbnail
      const maxWidth = thumbnailSize; // Adjust this as needed
      const maxHeight = thumbnailSize; // Adjust this as needed
      let width = videoDimensions.width;
      let height = videoDimensions.height;

      if (width > maxWidth || height > maxHeight) {
        const aspectRatio = width / height;
        if (width > maxWidth) {
          width = maxWidth;
          height = maxWidth / aspectRatio;
        }
        if (height > maxHeight) {
          height = maxHeight;
          width = maxHeight * aspectRatio;
        }
      }

      // Set the canvas size
      canvas.width = width;
      canvas.height = height;

      // Draw the image on the canvas to create the thumbnail
      ctx.drawImage(video, 0, 0, width, height);

      video.pause();

      // Convert the canvas to a Blob with JPG format
      canvas.toBlob(resolve, 'image/jpeg');
    };

    video.autoplay = true;
    video.muted = true;
    video.src = videoPath;
  });
}

async function readUserComment(json_raw) {
  let json_str = json_raw.substring(json_raw.indexOf("{"));
  json_str = json_str.trim();
  const json = JSON.parse(json_str);
  const userComment = json;
  const annotations = [];
  const meta = {};
  json.objects.forEach((obj) => {
    annotations.push({
      label_index: -1,
      label_name: obj.label,
      score: obj.score,
      x: obj.bbox.xmin,
      y: obj.bbox.ymin,
      w: obj.bbox.xmax - obj.bbox.xmin,
      h: obj.bbox.ymax - obj.bbox.ymin,
      type: 'box',
      polygon: '',
    });
  });

  if (json.device_id) {
    meta.source = json.device_id;
  }
  if (json.timestamp) {
    meta.timestamp = json.timestamp;
  }
  if (json.gps) {
    meta.gps = {};
    meta.gps.lat = json.gps.lat;
    meta.gps.lon = json.gps.lon;
  }
  return { annotations, meta, userComment };
}

async function getExifData(imageData) {
  // Try to get exif data
  let exifResult = {
    annotations: [],
    meta: {
      gps: {},
      timestamp: 0,
    },
  };
  const options = {
    userComment: true,
  };
  let exifData;
  try {
    exifData = await exifr.parse(imageData, options);
  } catch (error) {
    console.log(error);
    throw Error("Failed to parse EXIF");
  }
  if (!exifData) {
    return exifResult;
  }

  // Parse exif data
  if (exifData.latitude && exifData.longitude) {
    exifResult.meta.gps.lat = exifData.latitude;
    exifResult.meta.gps.lon = exifData.longitude;
  }
  if (exifData.DateTimeOriginal) {
    exifResult.meta.timestamp = Math.round(exifData.DateTimeOriginal.getTime() * 1000000);
  }

  if (exifData.userComment) {
    try {
      exifResult = readUserComment(exifData.userComment);
    } catch (error) {
      // Do Nothing
      console.error(error);
    }
  }

  return exifResult;
}

function parseImage(file) {
  return new Promise((resolve, reject) => {
    const imageInfo = {};
    // Function to extract EXIF data using exif-js library
    const reader = new FileReader();
    reader.onload = function (e) {
      const imageArrayBuffer = e.target.result;
      const image = new Image();
      image.onload = async function () {
        // Get image dimensions
        imageInfo.width = image.naturalWidth;
        imageInfo.height = image.naturalHeight;

        // const thumbnail = await createThumbnail(image);

        try {
          const exifData = await getExifData(imageArrayBuffer);
          imageInfo.exif = exifData;
        } catch (error) {
          console.log(error);
        }
        resolve({ imageInfo });
      };
      image.onerror = function () {
        reject(Error(`Failed to parse image: ${file.name}`));
      };

      image.src = URL.createObjectURL(file);
    };
    reader.onerror = function () {
      reject(Error(`Failed to parse image: ${file.name}`));
    };
    reader.readAsArrayBuffer(file);
  });
}

export {
  createThumbnail,
  createVideoThumbnail,
  parseImage,
};
